/**
 * @generated SignedSource<<358e5551b9f96dfe9a2afaafa76af9f2>>
 * @relayHash b12b1465b07b827d65b43ec315b31d5b
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-finding/433.0.0-2023-10-04T14:29:15.338Z/requestShipmentQuoteMutation

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ShipmentQuoteRequestInput = {
  action?: string | null;
  buyerId: string;
  city?: string | null;
  clientMutationId?: string | null;
  conversationId?: string | null;
  conversationIds?: ReadonlyArray<string | null> | null;
  country?: string | null;
  currencyConversionRateEventId?: string | null;
  dealerPk?: string | null;
  itemIds?: ReadonlyArray<string | null> | null;
  itemPk?: string | null;
  message: string;
  pageContext?: string | null;
  portfolioIds?: ReadonlyArray<string | null> | null;
  shippingAddressId?: string | null;
  state?: string | null;
  subject: string;
  transactionId?: string | null;
  transactionType?: string | null;
  zipCode?: string | null;
};
export type requestShipmentQuoteMutation$variables = {
  input: ShipmentQuoteRequestInput;
};
export type requestShipmentQuoteMutation$data = {
  readonly shipmentQuoteRequest: {
    readonly conversation: {
      readonly id: string;
      readonly serviceId: string | null;
      readonly transaction: {
        readonly id: string;
        readonly serviceId: string | null;
      } | null;
    } | null;
  } | null;
};
export type requestShipmentQuoteMutation = {
  response: requestShipmentQuoteMutation$data;
  variables: requestShipmentQuoteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ShipmentQuoteRequestPayload",
    "kind": "LinkedField",
    "name": "shipmentQuoteRequest",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Conversation",
        "kind": "LinkedField",
        "name": "conversation",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Transaction",
            "kind": "LinkedField",
            "name": "transaction",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "requestShipmentQuoteMutation",
    "selections": (v3/*: any*/),
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "requestShipmentQuoteMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "id": "app-buyer-finding/433.0.0-2023-10-04T14:29:15.338Z/requestShipmentQuoteMutation",
    "metadata": {},
    "name": "requestShipmentQuoteMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "0907d83770d95f82e909f436c2af3af8";

export default node;
